import React from 'react';

import Section from './Section';


const FullScreenTemplate = ({children}) => {
    return (<div style={{
        position: "fixed",
        zIndex: 23,
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        background: "#fff",
        }}>
        <Section className="intro_form">
            {children}
        </Section>
        </div>);
}

module.exports = FullScreenTemplate;



/** WEBPACK FOOTER **
 ** ./src/components/FullScreenTemplate.js
 **/